import styled from "styled-components";

export const Root = styled.span`
  font-size: ${({ theme }) => theme.font.size.sm};
  font-weight: ${({ theme }) => theme.font.weight.semibold};
  line-height: ${({ theme }) => theme.space.xl};
  color: ${({ $isValue, theme }) =>
    $isValue ? theme.colors.gray800 : theme.colors.gray400};
`;
